import { Component, Input } from '@angular/core';
import { PurchasePrice } from '../../models/purchase-price.model';

@Component({
  selector: 'app-purchase-price',
  templateUrl: './purchase-price.component.html',
  styleUrl: './purchase-price.component.scss',
})
export class PurchasePriceComponent {
  @Input({ required: true }) data!: PurchasePrice;

  get fullPrice(): number | null {
    if (this.data.price) {
      return this.data.price + (this.data.discount || 0);
    } else {
      return null;
    }
  }
}
